export const blockIconsMapsLocalActivityNew = (
	<span className='material-symbols-outlined'>local_activity</span>
);
